import { Container } from "@jds/core";
import { useRef, useState, useEffect } from "react";
import powerups from "../../images/powerup.png";
import './PowerUp.css';

const PowerUp = () => {
    const bottleRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
  
    useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setIsVisible(true);
            }
          });
        },
        { threshold: 0.5 }
      );
  
      if (bottleRef.current) {
        observer.observe(bottleRef.current);
      }
  
      const bottleRefCurrentValue = bottleRef.current;
  
      return () => {
        if (bottleRefCurrentValue) {
          observer.unobserve(bottleRefCurrentValue);
        }
      };
    }, []);
  
    return (
      <div>
        <Container
          className="newlarge"
          style={{
            width: "100%",
            padding: "6.389vw 9.375vw",
            justifyContent: "center",
            boxShadow: "120px 114px 50px 30px rgba(0, 0, 0, .05)",
            boxSizing: "border-box",
            background: "linear-gradient(0deg, #0462b0 10.16%, #000f36 56.5%)",
            marginTop: "-215px",
            position: "relative",
          }}
        >
          {/* <div style={{ height: '600px', borderRadius: "20px", color: "red", minWidth: "70%", boxShadow: '120px 114px 50px 30px rgba(0, 0, 0, .05)', display: 'flex', flexDirection: 'column', padding: '40px 26px 62px 62px', boxSizing: 'border-box' }}>
                      </div> */}
          <div className="yes">
            <div className="heightproblem" style={{ position: "relative" }}>
              <img
                alt="mask-group"
                className="changedimg"
                style={{
                  width: "100%",
                }}
                src="https://campabeveragesadmin.ril.com/uploads/Mask_group_ccffb78bd8.png"
              />
              <img
                className="bottle-img"
                ref={bottleRef}
                src={powerups}
                alt="Bottle"
                style={{
                  position: "absolute",
                  left: "3%",
                  bottom: "0",
                  height: "auto",
                  zIndex: 1,
  
                  //animation: 'slideUp 0.7s ease-out forwards',
                  animation: isVisible
                    ? "slideUp 0.7s ease-out forwards"
                    : "none",
                }}
              />
            </div>
  
            <img
              alt="great-taste"
              src="https://campabeveragesadmin.ril.com/uploads/unit_GIT_d1820c3fde.png"
              className="resized"
              style={{
                position: "absolute",
                top: "16%",
                left: "48%",
                zIndex: 3,
                width: "126px",
                height: "168px",
              }}
            />
            <div
              className="powerdiv"
              style={{
                position: "absolute",
                top: "30%",
                left: "48%",
                //   transform: 'translateY(-50%)',
                zIndex: 4,
              }}
            >
              <h5
                className="power"
                style={{
                  color: "#fff",
                  fontSize: "clamp(40px, 5vw, 72px)",
                  // fontWeight: '600',
                  // textAlign: 'center',
                  fontStyle: "italic",
                  textShadow: "10px 3px #441e8f",
                  padding: "70px 0 4px ",
                  marginBottom: "5px",
                  // textAlign: 'center',
                  fontFamily: "LogikWide",
                  textAlign: "left",
                  whiteSpace: "pre-wrap",
                  minWidth: "100%",
                }}
              >
                AB POWER APNE HATH MEIN
              </h5>
              <div className="firstdiv">
                <p
                  className="first"
                  style={{
                    margin: "0",
                    fontSize: "16px",
                    lineHeight: "24px",
                    color: "#fff",
                    padding: "0",
                    fontFamily: "LogikWide",
                    width: "auto",
                    textAlign: "left",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  From your very first sip till its last drop, experience a strong
                  Cola that puts the power in your hand, in a refreshing and
                  invigorating carbonated experience.
                </p>
              </div>
            </div>
          </div>
        </Container>
        <style>{`
                 
                
              `}</style>
      </div>
    );
  };

export default PowerUp;